import { FunctionComponent, useContext } from "react";

import ConsentPane from "../../widgets/general/consent-pane";
import TransferInfoPane from "../../widgets/general/transfer-info";
import OldAccountPane from "../../widgets/old-account";
import DestinationAccountPane from "../../widgets/destination-account";
import ConfirmTransferPane from "../../widgets/confirm-transfer";
import HomeScreen from "../../widgets/general/home-screen";
import PostTransferPane from "../../widgets/post-transfer/PostTransfer";
import ExploreIRAOptions from "../../widgets/explore-ira-options";
import {
  STEP_CONFIRM_TRANSFER_DETAILS,
  STEP_CONSENT,
  STEP_DESTINATION_ACCOUNT,
  STEP_DESTINATION_CONNECT_ES,
  STEP_DESTINATION_CONNECT_ES_DETAILS,
  STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT,
  STEP_DESTINATION_CONNECT_IRA,
  STEP_DESTINATION_CONNECT_IRA_TYPE,
  STEP_DESTINATION_EXPLORE_IRA,
  STEP_DESTINATION_EXPLORE_IRA_1,
  STEP_DESTINATION_EXPLORE_IRA_2,
  STEP_DESTINATION_EXPLORE_IRA_3,
  STEP_DESTINATION_EXPLORE_IRA_LOADING,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI,
  STEP_DESTINATION_EXPLORE_IRA_OPTIONS,
  STEP_DESTINATION_EXPLORE_IRA_RESULT,
  STEP_DESTINATION_FLASH_LOADING,
  STEP_DESTINATION_HELP,
  STEP_DESTINATION_HELP_1,
  STEP_DESTINATION_HELP_2,
  STEP_DESTINATION_HELP_3,
  STEP_DESTINATION_HELP_4,
  STEP_DESTINATION_HELP_5,
  STEP_DESTINATION_HELP_6A,
  STEP_DESTINATION_HELP_6B,
  STEP_DESTINATION_HELP_6C,
  STEP_DESTINATION_HELP_RESULT,
  STEP_DESTINATION_HELP_RESULT_LOADING,
  STEP_DESTINATION_OPEN_AND_CONNECT_IRA,
  STEP_DESTINATION_OPTIONS,
  STEP_DESTINATION_OPTIONS_TYPE,
  STEP_INITIATE_TRANSFER,
  STEP_IRA_EXIT_SCREEN,
  STEP_IRA_OPEN_FORM,
  STEP_MAILING_ADDRESS,
  STEP_MARTIAL_INFO,
  STEP_OLD_ACCOUNT_COMPLETED_HOME,
  STEP_OLD_ACCOUNT_CONFIRM,
  STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS,
  STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT,
  STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT,
  STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN,
  STEP_OLD_ACCOUNT_PROVIDER_SEARCH,
  STEP_OLD_ACCOUNT_SPONSOR_NAME,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED,
  STEP_OPEN_IRA,
  STEP_PERSONAL_INFO,
  STEP_POST_TRANSFER,
  STEP_SCHEDULE_PHONE_CALL,
  STEP_SCHEDULE_PHONE_CALL_CONFIRMATION,
  STEP_SCHEDULE_PHONE_CALL_NO_LOADING,
  STEP_TRANSFER_INFO,
  STEP_DESTINATION_IRA_METHODOLOGY_SCREEN,
  STEP_DESTINATION_METHODOLOGY_SCREEN,
  STEP_DESTINATION_CHOICES,
  STEP_ANNUITY_CONTACT,
  STEP_IDENTITY_VERIFICATION_PERSONA,
  STEP_IDENTITY_VERIFICATION,
  STEP_SPOUSE_NOTARY,
  STEP_TRANSFER_TASKS,
  NETWORK_ERROR_SCREEN,
  STEP_FAILED_ID_VERIFICATION,
  STEP_SCHEDULE_PHONE_CALL_LOADING,
} from "../../class/transferDetails";
import { TransferContext } from "../../context/TransferContext";
import { UNEXPECTED_ERROR_MESSAGE } from "../../typings";
import OpenIRAAnimationPane from "../../widgets/open-ira/OpenIRAAnimationPane";
import OpenIRAExitScreen from "../../widgets/open-ira/OpenIRAExitScreen";
import ScheduleZohoPhoneCall from "../../widgets/post-transfer/ScheduleZohoPhoneCall";
import SchedulePhoneCallConfirmation from "../../widgets/post-transfer/SchedulePhoneCallConfirmation";
import HenryQuestionnaire from "../../widgets/henry-questionniare";
import AnnuityContactScreen from "../../widgets/post-transfer/AnnuityContactScreen";
import TransferTasks from "../../widgets/transfer-tasks";
import NetworkErrorPane from "../../widgets/general/error-pane/NetworkErrorPane";
import SchedulePhoneCallFlashLoading from "../../widgets/post-transfer/SchedulePhoneCallFlashLoading";

const Screen: FunctionComponent = () => {
  const { currentScreen, shouldShowHomeScreen, setShowError } = useContext(TransferContext);

  if (shouldShowHomeScreen) {
    return <HomeScreen />;
  }

  switch (currentScreen) {
    case STEP_CONSENT:
      return <ConsentPane />;
    case STEP_TRANSFER_INFO:
      return <TransferInfoPane />;
    case STEP_OLD_ACCOUNT_SPONSOR_NAME:
    case STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT:
    case STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT:
    case STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS:
    case STEP_OLD_ACCOUNT_PROVIDER_SEARCH:
    case STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN:
    case STEP_OLD_ACCOUNT_UPLOAD_STATEMENT:
    case STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED:
    case STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT:
    case STEP_OLD_ACCOUNT_COMPLETED_HOME:
    case STEP_OLD_ACCOUNT_CONFIRM:
      return <OldAccountPane />;
    case STEP_DESTINATION_ACCOUNT:
    case STEP_DESTINATION_FLASH_LOADING:
    case STEP_DESTINATION_CONNECT_ES:
    case STEP_DESTINATION_CONNECT_IRA:
    case STEP_DESTINATION_CONNECT_IRA_TYPE:
    case STEP_DESTINATION_OPTIONS:
    case STEP_DESTINATION_CHOICES:
    case STEP_DESTINATION_OPTIONS_TYPE:
    case STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT:
    case STEP_DESTINATION_CONNECT_ES_DETAILS:
    case STEP_DESTINATION_OPEN_AND_CONNECT_IRA:
      return <DestinationAccountPane />;
    case STEP_DESTINATION_HELP:
    case STEP_DESTINATION_HELP_1:
    case STEP_DESTINATION_HELP_2:
    case STEP_DESTINATION_HELP_3:
    case STEP_DESTINATION_HELP_4:
    case STEP_DESTINATION_HELP_5:
    case STEP_DESTINATION_HELP_6A:
    case STEP_DESTINATION_HELP_6B:
    case STEP_DESTINATION_HELP_6C:
    case STEP_DESTINATION_HELP_RESULT_LOADING:
    case STEP_DESTINATION_HELP_RESULT:
    case STEP_DESTINATION_METHODOLOGY_SCREEN:
      return <HenryQuestionnaire />;
    case STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD:
    case STEP_DESTINATION_EXPLORE_IRA:
    case STEP_DESTINATION_EXPLORE_IRA_1:
    case STEP_DESTINATION_EXPLORE_IRA_2:
    case STEP_DESTINATION_EXPLORE_IRA_3:
    case STEP_DESTINATION_EXPLORE_IRA_LOADING:
    case STEP_DESTINATION_EXPLORE_IRA_RESULT:
    case STEP_DESTINATION_EXPLORE_IRA_OPTIONS:
    case STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY:
    case STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT:
    case STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI:
    case STEP_DESTINATION_IRA_METHODOLOGY_SCREEN:
      return <ExploreIRAOptions />;
    case STEP_IRA_OPEN_FORM:
    case STEP_CONFIRM_TRANSFER_DETAILS:
    case STEP_PERSONAL_INFO:
    case STEP_MARTIAL_INFO:
    case STEP_MAILING_ADDRESS:
    case STEP_INITIATE_TRANSFER:
    case STEP_IDENTITY_VERIFICATION:
    case STEP_IDENTITY_VERIFICATION_PERSONA:
    case STEP_FAILED_ID_VERIFICATION:
      return <ConfirmTransferPane />;
    case STEP_POST_TRANSFER:
      return <PostTransferPane />;

    case STEP_SCHEDULE_PHONE_CALL:
    case STEP_SCHEDULE_PHONE_CALL_NO_LOADING:
      return <ScheduleZohoPhoneCall shouldShowAnimation={currentScreen === STEP_SCHEDULE_PHONE_CALL_NO_LOADING} />;
    case STEP_SCHEDULE_PHONE_CALL_CONFIRMATION:
      return <SchedulePhoneCallConfirmation />;
    case STEP_OPEN_IRA:
      return <OpenIRAAnimationPane />;
    case STEP_IRA_EXIT_SCREEN:
      return <OpenIRAExitScreen />;
    case STEP_ANNUITY_CONTACT:
      return <AnnuityContactScreen />;
    case STEP_TRANSFER_TASKS:
    case STEP_SPOUSE_NOTARY:
      return <TransferTasks />;
    case STEP_SCHEDULE_PHONE_CALL_LOADING:
      return <SchedulePhoneCallFlashLoading />;
    case NETWORK_ERROR_SCREEN:
      return <NetworkErrorPane />;
    default:
      setShowError(UNEXPECTED_ERROR_MESSAGE);
      throw Error(UNEXPECTED_ERROR_MESSAGE);
  }
};

export default Screen;
